import { FC, useContext, useEffect } from 'react'
import { observer } from 'mobx-react'
import { EditorViewContainer } from './MainGrid.styles'
import { Header } from './components/Header/Header'
import { Menu } from './components/Menu/Menu'
import { StoreContext } from '@components/App'

import { ConfigurationView } from '@modules/Configurations/ConfigurationView'
import { AccessManagement } from '@modules/AccessManagement/AccessManagement'
import { Settings } from '@modules/Settings/Settings'
import { Tools } from '@modules/Tools/Tools'
import { appMetadata } from '@/constants/appMetadata'

export const MainGrid: FC = observer(() => {
  const store = useContext(StoreContext)
  const { selectedMenuTab } = store.UserInterfaceState
  const { menuWidth, headerHeight } = store.UserInterfaceState.gridDimensions

  const renderSelectedTab = () => {
    switch (selectedMenuTab) {
      case 'configurations':
        return <ConfigurationView />
      case 'permissions':
        return <AccessManagement />
      case 'tools':
        return <Tools />
      case 'bugs':
        return <h1>Bugs</h1>
      case 'settings':
        return <Settings />
      default:
        return <></>
    }
  }

  useEffect(() => {
    const shouldShowChangelog = localStorage.getItem('lastChangelogVersion') !== appMetadata.versionIndex

    if (shouldShowChangelog) {
      store.ModalState.openModal('changelog')
    }
  }, [])

  return (
    <EditorViewContainer $headerHeight={`${headerHeight}px`} $menuWidth={`${menuWidth}px`}>
      <Header />
      <Menu />

      {renderSelectedTab()}
    </EditorViewContainer>
  )
})
